import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { APPLICANTS_LIST_KEY } from './useApplicants'

export type ApplicantInvite = {
  email: string
  name?: string
}

type InviteApplicantsPayload = {
  applicants: ApplicantInvite[]
}

export type InviteApplicantFailureReason = 'duplicate' | 'error'

export type InviteApplicantsResult = {
  failed: { email: string; reason: InviteApplicantFailureReason }[]
}

export function useInviteApplicants() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ applicants }: InviteApplicantsPayload) =>
      (await apiClient.post<InviteApplicantsResult>('/int/v3/users/applicants/invite', { applicants })).data,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [APPLICANTS_LIST_KEY] })
    },
  })
}
